import React from 'react';

import { Icons } from 'lusha-ui-components-v2';

import { PROSPECTING_TABS } from '../../models/Search/constants';

export const SEARCH_TITLE = 'Search';

export const SEARCH_TABS = {
  contacts: 'contacts',
  companies: 'companies',
};

export const tabs = [
  {
    key: 'contacts',
    label: 'Contacts',
    defaultChecked: false,
    'data-test-id': `tab-${PROSPECTING_TABS.company}`,
    icon: <Icons.PeopleFilled />,
  },
  {
    key: 'companies',
    label: 'Companies',
    defaultChecked: false,
    icon: <Icons.CompanyFilled />,
    'data-test-id': `tab-${PROSPECTING_TABS.employees}`,
  },
];
